import React from 'react';

import SchedulingFrequencySelector from '../SchedulingFrequencySelector/SchedulingFrequencySelector';

interface SchedulingBodyProps {
  repeatInterval: number;
  onIntervalChange: (value: number) => void;
  timeLabel: string;
  disabled: boolean;
  onEmptyChange?: (isEmpty: boolean) => void;
  dataTestId?: string;
}

/**
 * SchedulingBody
 * --------------
 * Renders frequency selector, weekly day picker, and next run-time display.
 */
function SchedulingBody({
  repeatInterval,
  onIntervalChange,
  timeLabel,
  disabled,
  onEmptyChange = undefined,
  dataTestId,
}: SchedulingBodyProps) {
  return (
    <div className='scheduling-body' data-testid={dataTestId}>
      {/* Interval selector for weeks */}
      <SchedulingFrequencySelector
        disabled={disabled}
        interval={repeatInterval}
        onIntervalChange={onIntervalChange}
        onEmptyChange={onEmptyChange}
        timeLabel={timeLabel}
      />
    </div>
  );
}

SchedulingBody.defaultProps = {
  onEmptyChange: undefined,
  dataTestId: undefined,
};

export default SchedulingBody;
